/**
 * Shared Admin Formatting Utilities
 * Reusable formatters and style maps for admin tabs
 */

import { formatCents } from '@parlay-picker/shared/formatting';

// Re-export shared formatCents for convenience
export { formatCents };

/**
 * Format an ISO date string for admin display
 * e.g., "Mar 20, 2026, 02:30 PM"
 */
export function formatAdminDate(dateString: string | null): string {
  if (!dateString) return '--';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Payout status badge colors */
export const PAYOUT_STATUS_STYLES: Record<string, string> = {
  calculated: 'bg-yellow-500/10 text-yellow-500',
  transferred: 'bg-green-500/10 text-green-500',
  failed: 'bg-red-500/10 text-red-500',
};

/** Payout status display labels */
export const PAYOUT_STATUS_LABELS: Record<string, string> = {
  calculated: 'Pending',
  transferred: 'Paid',
  failed: 'Failed',
};

/** Dispute status badge colors */
export const DISPUTE_STATUS_STYLES: Record<string, string> = {
  open: 'bg-yellow-500/10 text-yellow-500',
  won: 'bg-green-500/10 text-green-500',
  lost: 'bg-red-500/10 text-red-500',
};

/** Dispute status display labels */
export const DISPUTE_STATUS_LABELS: Record<string, string> = {
  open: 'Open',
  won: 'Won',
  lost: 'Lost',
};
